import React, { useEffect, useState } from "react";
import {
  Box,
  Text,
  SimpleGrid,
  Button,
  HStack,
  Grid,
  GridItem,
} from "@chakra-ui/react";
import HerVestTable from "../components/Table/HervestTable";
import moment from "moment";
import { formatMoney } from "../services/utils/helpersFunc";
import ModalLayout from "../components/Layout/ModalLayout";
import { getInstantLoanRepaymentSchedules } from "../services/axios";
import FilterComponent from "../components/Inputs/FilterComponent";
import { convertArrayOfObjectsToWorksheet } from "../services/utils/helpersFunc";
import { useNavigate } from "react-router-dom";

const columns = [
  {
    name: "S/N",
    key: "id",
  },
  {
    name: "Amount Due",
    key: "amount_due",
  },
  {
    name: "Due Date",
    key: "date",
  },
  {
    name: "Email",
    key: "email",
  },
  {
    name: "Phone Number",
    key: "phone",
  },
  {
    name: "Loan Amount",
    key: "loan_amount",
  },
  {
    name: "Loan Disbursed",
    key: "loan_disbused",
  },
  {
    name: "Duration",
    key: "duration",
  },
  {
    name: "Request Id",
    key: "request_id",
  },
  {
    name: "Debit Attempts",
    key: "trials",
  },
  {
    name: "Loan Status",
    key: "loan_status",
  },
  {
    name: "Repayment Status",
    key: "status",
  },
];

function InstantLoanRepaymentScedule() {
  const navigate = useNavigate();

  const [allRepaymentSchedules, setallRepaymentSchedules] = useState([]);
  const [loading, setLoading] = useState(false);
  const [meta, setMeta] = useState({});
  const [openDetails, setOpenDetails] = useState(false);
  const [selectedDetails, setSelectedDetails] = useState({});
  const [filters, setFilters] = React.useState({
    page: 1,
    pageLimit: 50,
  });

  const getallRepaymentSchedules = async () => {
    setLoading(true);
    const res = await getInstantLoanRepaymentSchedules(filters);
    setLoading(false);
    if (res) {
      const mappedData = res.data.data.map((data, index) => {
        return {
          ...data,
          created_at: moment(data.created_at).format("DD/MM/YYYY"),
        };
      });
      setallRepaymentSchedules(mappedData);
      setMeta(res?.data?.meta);
    }
    return;
  };

  const handlePageClick = (page) => {
    setFilters({
      ...filters,
      page: page.selected + 1,
      pageLimit: 50,
    });
    getallRepaymentSchedules();
  };

  useEffect(() => {
    getallRepaymentSchedules();
    // eslint-disable-next-line
  }, [filters]);

  const downloadHandler = async () => {
    const res = await getInstantLoanRepaymentSchedules({
      ...filters,
      exportData: true,
    });

    if (res) {
      const formattedData = res.data.map((item) => ({
        "Due Date": moment(item.date).format("DD-MMM-YYYY"),
        "Amount Due": `₦${formatMoney(item.amount_due)}`,
        "Debit Attempts": item.instant_loan_repayment_schedules_trials || 0,
        "Request Id": item.instant_loan_repayment_schedules_request_id || "-",
        Email: item?.user_email || "-",
        "Phone Number": item?.user_phone || "-",
        "Loan Amount": `₦${formatMoney(item?.instant_loan_amount) || "-"}`,
        "Repayment Status":
          item?.instant_loan_repayment_schedules_status || "-",
        Duration:
          `${item?.instant_loan_tenure} Month${
            item?.instant_loan_tenure > 1 ? "s" : ""
          }` || "-",
      }));
      return convertArrayOfObjectsToWorksheet(
        formattedData,
        `Instant Loans Repayments-${moment().format("LLL")}`
      );
    }
  };

  return (
    <Box
      bg="#F8F9FC"
      p={["20px 10px", "20px 10px", "20px 10px 20px 30px"]}
      h="100vh"
      w="100%"
    >
      <Text
        color="#5B2E4F"
        fontSize="18px"
        fontWeight="500"
        fontFamily="satoshiBold"
      >
        Instant Loan Repayment Schedules
      </Text>

      <Grid templateColumns="repeat(4, 1fr)" gap={6}>
        <GridItem>
          <HStack
            justify="space-between"
            bg="#F8F1F6"
            borderRadius="6px"
            p="20px"
            marginTop="5"
            spacing={["10px", "20px"]}
          >
            <Box>
              <Text
                fontSize={["13px", "15px"]}
                color="#33343D"
                fontWeight="500"
                fontFamily="satoshiBold"
              >
                Total Due Amount
              </Text>
              <Text
                fontSize="21px"
                fontFamily="satoshiBolder"
                color="#5B2E4F"
                lineHeight="28.35px"
              >
                ₦ {formatMoney(meta?.summary?.total_retrying || 0)}
              </Text>
            </Box>
          </HStack>
        </GridItem>
        <GridItem>
          <HStack
            justify="space-between"
            bg="#F8F1F6"
            borderRadius="6px"
            p="20px"
            marginTop="5"
            spacing={["10px", "20px"]}
          >
            <Box>
              <Text
                fontSize={["13px", "15px"]}
                color="#33343D"
                fontWeight="500"
                fontFamily="satoshiBold"
              >
                Total Upcoming Payments
              </Text>
              <Text
                fontSize="21px"
                fontFamily="satoshiBolder"
                color="#5B2E4F"
                lineHeight="28.35px"
              >
                ₦ {formatMoney(meta?.summary?.total_not_due || 0)}
              </Text>
            </Box>
          </HStack>
        </GridItem>
        <GridItem>
          <HStack
            justify="space-between"
            bg="#F8F1F6"
            borderRadius="6px"
            p="20px"
            marginTop="5"
            spacing={["10px", "20px"]}
          >
            <Box>
              <Text
                fontSize={["13px", "15px"]}
                color="#33343D"
                fontWeight="500"
                fontFamily="satoshiBold"
              >
                Total Paid/Recovered Loans
              </Text>
              <Text
                fontSize="21px"
                fontFamily="satoshiBolder"
                color="#5B2E4F"
                lineHeight="28.35px"
              >
                ₦ {formatMoney(meta?.summary?.total_paid || 0)}
              </Text>
            </Box>
          </HStack>
        </GridItem>
      </Grid>

      <FilterComponent
        filters={filters}
        setFilters={setFilters}
        downloadHandler={downloadHandler}
        statusData={[
          { name: "Paid", value: "Paid" },
          { name: "Retrying", value: "Retrying" },
          { name: "Not Due", value: "Not Due" },
          { name: "Disbursement Declined", value: "DISBURSEMENT_DECLINED" },
        ]}
      />

      <HerVestTable
        onClickHandler={(item) => {
          setSelectedDetails(item);
          setOpenDetails(true);
        }}
        meta={meta}
        data={(
          (!loading && allRepaymentSchedules && allRepaymentSchedules) ||
          []
        ).map((item, index) => ({
          ...item,
          id: index + 1,
          amount_due: `₦${formatMoney(item.amount_due)}`,
          status: item.status,
          date: moment(item.date).format("DD-MMM-YYYY"),
          trials: item.trials || 0,
          request_id: item.request_id || "-",
          email: item?.user?.email || "-",
          phone: item?.user?.phone || "-",
          loan_amount: `₦${formatMoney(item?.loan?.amount) || "-"}`,
          loan_status: item?.loan?.status || "-",
          loan_disbused: item?.request?.loan_disbursed ? "Yes" : "No",
          duration:
            `${item?.loan?.tenure} Month${item?.loan?.tenure > 1 && "s"}` ||
            "-",
        }))}
        columns={columns}
        handlePageClick={(value) => handlePageClick(value)}
      />

      {/* //DETAILS MODAL STARTS HERE  */}
      <ModalLayout
        setIsOpen={setOpenDetails}
        title="Loan Repayment Details"
        hideFooter={true}
        isOpen={openDetails}
      >
        <Box bg="#FFFFFF" my="20px" borderRadius="10px">
          <SimpleGrid
            spacing="20px"
            minChildWidth={["100px", "70px", "50px"]}
            p="20px"
            border="1px solid #E4E8F2"
          >
            <Box>
              <Text
                opacity="0.81px"
                fontWeight="500"
                fontSize="10px"
                color="#666666"
                lineHeight="18px"
              >
                AMOUNT DUE
              </Text>
              <Text
                fontWeight="500"
                fontSize="14px"
                color="#33343D"
                lineHeight="18px"
                fontFamily="satoshiBold"
              >
                {selectedDetails?.amount_due || "-"}
              </Text>
            </Box>

            <Box>
              <Text
                opacity="0.81px"
                fontWeight="500"
                fontSize="10px"
                color="#666666"
                lineHeight="18px"
              >
                REQUEST ID
              </Text>
              <Text
                fontWeight="500"
                fontSize="14px"
                color="#33343D"
                lineHeight="18px"
                fontFamily="satoshiBold"
              >
                {selectedDetails?.request_id || "-"}
              </Text>
            </Box>
          </SimpleGrid>
          <SimpleGrid
            spacing="20px"
            minChildWidth={["100px", "70px", "50px"]}
            p="20px"
            border="1px solid #E4E8F2"
          >
            <Box>
              <Text
                opacity="0.81px"
                fontWeight="500"
                fontSize="10px"
                color="#666666"
                lineHeight="18px"
              >
                CUSTOMER EMAIL
              </Text>
              <Text
                fontWeight="500"
                fontSize="14px"
                color="#33343D"
                lineHeight="18px"
                fontFamily="satoshiBold"
              >
                {selectedDetails?.user?.email || "-"}
              </Text>
            </Box>

            <Box>
              <Text
                opacity="0.81px"
                fontWeight="500"
                fontSize="10px"
                color="#666666"
                lineHeight="18px"
              >
                CUSTOMER PHONE NUMBER
              </Text>
              <Text
                fontWeight="500"
                fontSize="14px"
                color="#33343D"
                lineHeight="18px"
                fontFamily="satoshiBold"
              >
                {selectedDetails?.user?.phone || "-"}
              </Text>
            </Box>
          </SimpleGrid>
          <SimpleGrid
            spacing="20px"
            minChildWidth={["100px", "70px", "50px"]}
            p="20px"
            border="1px solid #E4E8F2"
          >
            <Box>
              <Text
                opacity="0.81px"
                fontWeight="500"
                fontSize="10px"
                color="#666666"
                lineHeight="18px"
              >
                LOAN AMOUNT
              </Text>
              <Text
                fontWeight="500"
                fontSize="14px"
                color="#33343D"
                lineHeight="18px"
                fontFamily="satoshiBold"
              >
                N {formatMoney(selectedDetails?.loan?.amount) || "-"}
              </Text>
            </Box>

            <Box>
              <Text
                opacity="0.81px"
                fontWeight="500"
                fontSize="10px"
                color="#666666"
                lineHeight="18px"
              >
                OPENING BALANCE
              </Text>
              <Text
                fontWeight="500"
                fontSize="14px"
                color="#33343D"
                lineHeight="18px"
                fontFamily="satoshiBold"
              >
                N {formatMoney(selectedDetails?.loan?.opening_balance) || "-"}
              </Text>
            </Box>
          </SimpleGrid>
          <SimpleGrid
            spacing="20px"
            minChildWidth={["100px", "70px", "50px"]}
            p="20px"
            border="1px solid #E4E8F2"
          >
            <Box>
              <Text
                opacity="0.81px"
                fontWeight="500"
                fontSize="10px"
                color="#666666"
                lineHeight="18px"
              >
                CURRENCT BALANCE
              </Text>
              <Text
                fontWeight="500"
                fontSize="14px"
                color="#33343D"
                lineHeight="18px"
                fontFamily="satoshiBold"
              >
                N {formatMoney(selectedDetails?.loan?.current_balance) || "-"}
              </Text>
            </Box>

            <Box>
              <Text
                opacity="0.81px"
                fontWeight="500"
                fontSize="10px"
                color="#666666"
                lineHeight="18px"
              >
                CLOSING BALANCE{" "}
              </Text>
              <Text
                fontWeight="500"
                fontSize="14px"
                color="#33343D"
                lineHeight="18px"
                fontFamily="satoshiBold"
              >
                N {formatMoney(selectedDetails?.loan?.closing_balance) || "-"}
              </Text>
            </Box>
          </SimpleGrid>
          <SimpleGrid
            spacing="20px"
            minChildWidth={["100px", "70px", "50px"]}
            p="20px"
            border="1px solid #E4E8F2"
          >
            <Box>
              <Text
                opacity="0.81px"
                fontWeight="500"
                fontSize="10px"
                color="#666666"
                lineHeight="18px"
              >
                DUE DATE
              </Text>
              <Text
                fontWeight="500"
                fontSize="14px"
                color="#33343D"
                lineHeight="18px"
                fontFamily="satoshiBold"
              >
                {selectedDetails?.date || "-"}
              </Text>
            </Box>
            <Box>
              <Text>
                <Button
                  bg="#5B2E4F"
                  color="white"
                  fontSize="12px"
                  fontWeight="800"
                  fontFamily="satoshiBold"
                  p="13px 35px"
                  ml="20px"
                  onClick={() =>
                    navigate(`/instant-loan/${selectedDetails?.request_id}`)
                  }
                >
                  VIEW LOAN
                </Button>
              </Text>
            </Box>
          </SimpleGrid>
        </Box>
      </ModalLayout>
    </Box>
  );
}

export default InstantLoanRepaymentScedule;
